import spherelibUtils from 'spherelib-utils'
import { matchName } from '../utils/match_name.js'
import { cacheFn, updateFnCache } from '../utils/cache.js'

const { sleep } = spherelibUtils
const { log, logErr } = spherelibUtils.log

export default ({
  getWorkerClient,

  // [{match, cacheOptions, updateCachesInLoop}], cacheOptions={name, expiry, keyFn}
  functionsToCache = [],
}) => {
  const updates = []

  const updateCachesLoop = async ({
    updateCachesInLoop, // {paramsList=[ [], ... ], interval}
    name,
    fn,
    cacheOptions,
  }) => {
    while (true) {
      try {
        await Promise.all(
          updateCachesInLoop.paramsList.map(async (params = []) => {
            log('update cache start', name, params)

            await updateFnCache(getWorkerClient, fn, params, cacheOptions)

            log('update cache done', name, params)
          }),
        )
      } catch (err) {
        logErr('update cache error', name, err, err && err.stack)
      }

      await sleep(updateCachesInLoop.interval * 1000)
    }
  }

  return {
    // wrapper
    wrapper: (name, fn) => {
      for (let i = 0; i < functionsToCache.length; i++) {
        const { match, cacheOptions, updateCachesInLoop } = functionsToCache[i]

        if (matchName(match, name)) {
          const cacheOptionsWithName = Object.assign(
            {
              name: `sapi-${name}`,
            },
            cacheOptions,
          )

          if (updateCachesInLoop) {
            updates.push({
              updateCachesInLoop,
              name,
              fn,
              cacheOptions: cacheOptionsWithName,
            })
          }

          return cacheFn(getWorkerClient, fn, cacheOptionsWithName)
        }
      }

      return fn
    },

    loopUpdateCaches: () => {
      for (let i = 0; i < updates.length; i++) {
        updateCachesLoop(updates[i])
      }
    },
  }
}
